export default __webpack_public_path__ + "static/media/nodejs-logo.583d3bb3.svg";